import React from "react";
import logo from "../keyline logo white.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="bg-black text-white">
      <div className="xl:px-36 lg:px-24 md:px-16 px-10   flex flex-col justify-between  xl:h-[79vh] h-auto  md:pt-14 py-10 ">
        <div className=" grid xl:grid-cols-4 md:gap-x-14 gap-x-0  gap-y-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 text-white ">
          <div className="space-y-2">
            <ul className="text-sm">
              <li>
                <Link to="/">
                  <div className="pb-4 md:h-10 h-8">
                    <img src={logo} className="h-full" alt="logo" />
                  </div>
                </Link>
              </li>
              <li className="hover:opacity-50  transition-all">
                <Link to="tel:+92 333 448 7714">
                  <div className="flex items-center space-x-4">
                    <i class="fa-solid fa-phone"></i>
                    <p>+92 333 448 7714</p>
                  </div>
                </Link>
              </li>
              <li className="hover:opacity-50  transition-all">
                <Link to="mailto:ahsan@keylinesolution.com">
                  <div className="phone flex items-center space-x-4 ">
                    <i class="fa-solid fa-envelope text-lg"></i>
                    <p>ahsan@keylinesolution.com</p>
                  </div>
                </Link>
              </li>
              <li className="hover:opacity-50  transition-all">
                <div className="flex items-start space-x-4  cursor-pointer">
                  <i class="fa-solid fa-location-dot text-lg"></i>
                  <p className="">
                    Shop # 05 First Floor Masjid Khulfa-e-Rashideen Royal Park,
                    Lakhsmi Chowk, Lahore, Pakistan.54000
                  </p>
                </div>
              </li>
              <li className="hover:opacity-50 transition-all">
                <Link to="https://wa.link/zubwqi">
                  <div className="flex items-center space-x-4">
                    <i class="fa-brands fa-whatsapp text-lg"></i>
                    <p className="hover:text-gray-300 transition-all">
                      +92 333 448 7714
                    </p>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
          <div className="">
            <div className="">
              <h2 className="pb-2">PRINT SHOP</h2>
              <ul className="text-white text-sm">
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/product/1">Business Cards</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/product/2">Leaflets / Flyers</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/product/4">Postcards</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/product/3">Poster Printing</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="">
            <div className="">
              <h2 className="pb-2">Help</h2>
              <ul className="text-white  text-sm">
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/">Document Prep Guide</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/">Design</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/faqs">FAQs</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/">Terms & Conditions</Link>
                </li>
                <li className="hover:opacity-100 opacity-50">
                  <Link to="/policy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="">
            <h2 className="pb-2">SAMPLE PACK REQUEST</h2>
            <form action="">
              <div className="form space-y-2 w-full">
                <input
                  className="bg-white p-1 border-none outline-none text-black rounded-sm w-full"
                  placeholder="Your Name"
                  type="text"
                  name=""
                  id=""
                />
                <input
                  className="bg-white p-1 border-none outline-none text-black rounded-sm w-full"
                  placeholder="Your Email"
                  type="email"
                  name=""
                  id=""
                />
                <input
                  className="bg-white p-1 border-none outline-none text-black rounded-sm w-full"
                  placeholder="Your Address"
                  type="email"
                  name=""
                  id=""
                />
              </div>
              <input
                className=" w-full font-medium rounded-sm bg-white my-4 text-black hover:bg-black hover:border-2 border-2 border-transparent hover:border-white hover:text-white transition-all py-1"
                type="submit"
                value="Submit"
              />
            </form>
          </div>
        </div>
        <div className="copyright flex  md:justify-between md:flex-row flex-col text-center ">
          <h2 className="opacity-30    text-sm">
            Copyright © 2020-2025 Keyline Solution. All rights reserved.
          </h2>
          <h2 className="opacity-30     text-sm">
            Website By{" "}
            <Link to="https://afaqmasood.netlify.app/" target="_blank">
              M.AFAQ.
            </Link>
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Footer;
